import React, { memo, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Row, Col, Modal } from 'react-bootstrap';
import MypageReturn from '../molecules/MypageReturn';
import Popup from '../molecules/Popup';

interface Props {
  is_changing: boolean; // 申込人が変更中（true=変更中）
  is_staff: boolean;
  reception_cd: string;
  reception_id: number;
  clickAgree: () => Promise<any>;
  clickDisagree: () => Promise<any>;
  status_code: number;
  is_implement_online_identification?: boolean;
  is_guarantor_agreement: boolean;
}

// KWANKGM02060_借入相談内容照会（連帯債務者等）
const FooterBorrowingConsultationDetailsInquiry: React.FC<Props> = ({
  is_changing,
  is_staff,
  reception_cd,
  reception_id,
  clickAgree,
  clickDisagree,
  status_code,
  is_guarantor_agreement,
}) => {
  const history = useHistory();
  const [modal_disagree, setModalDisagree] = useState(false);
  const [modal_error, setModalError] = useState(false);

  // 同意する・同意しないボタンの表示
  const outputAgreeButton = () => {
    if (is_changing) {
      return <></>;
    }

    return (
      <Row className="mt-5 flex-lg-row flex-md-reverse flex-sm-column-reverse flex-column-reverse">
        <Col xs={12} sm={12} md={12} lg={6} xl={6} className="row-left-button-danger">
          <div className="text-left sp-button-center">
            <a
              className={`btn btn-xl btn-danger sp-btn-height ${!is_guarantor_agreement &&
                'disabled-bg'}`}
              onClick={handleClickOpenDisagree}
            >
              同意しない
            </a>
          </div>
        </Col>
        <Col xs={12} sm={12} md={12} lg={6} xl={6} className="row-right-button-small">
          <div className="text-right sp-button-center">
            <a
              className={`btn btn-xl btn-main-color sp-btn-height ml-auto ${!is_guarantor_agreement &&
                'disabled-bg'}`}
              onClick={handleClickAgree}
            >
              同意する
            </a>
          </div>
        </Col>
      </Row>
    );
  };

  // 「同意しない」ボタンクリック時のアクション
  const handleClickOpenDisagree = () => {
    // 連帯債務者が同意文を確認していない場合は後続の処理をしない
    if (!is_guarantor_agreement) return;

    setModalDisagree(true);
  };

  // 「同意する」ボタンクリック時のアクション
  const handleClickAgree = async () => {
    // 連帯債務者が同意文を確認していない場合は後続の処理をしない
    if (!is_guarantor_agreement) return;

    const valid_result = await clickAgree();
    // バリデーションエラーがあるか判定
    if (valid_result) {
      // エラーが無ければ確認画面へ遷移
      history.push(`/reception/${reception_cd}/${reception_id}/${status_code}/agree`);
    }
  };

  // 辞退確認ダイアログの「辞退する」ボタンクリック時のアクション
  const handleClickDisagree = async () => {
    const result = await clickDisagree();
    if (result) {
      history.push(`/reception/${reception_cd}/${reception_id}/${status_code}/disagree`);
    }
  };

  return (
    <>
      {outputAgreeButton()}
      <MypageReturn is_staff={is_staff} />
      <Popup
        title="不同意の確認"
        text="借入相談申込の内容に不同意を表明します。よろしいですか？"
        first_button={{
          label: '同意しない',
          variant: 'danger',
          handleClick: () => {
            handleClickDisagree();
            setModalDisagree(false);
          },
        }}
        second_button={{
          label: '戻る',
          variant: 'outline-success',
          handleClick: () => setModalDisagree(false),
        }}
        toggleClose={() => setModalDisagree(false)}
        toggleShow={modal_disagree}
      />
      {/* エラーダイアログ */}
      <Modal
        show={modal_error}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        onHide={() => {}}
      >
        <Modal.Body>システムエラーが発生しました。</Modal.Body>
        <Modal.Footer>
          <a className="btn btn-outline-success" onClick={() => setModalError(false)}>
            OK
          </a>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default memo(FooterBorrowingConsultationDetailsInquiry);
